import { Component, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';

import {
  FormGroup,
  FormControl,
  Validators
} from '@angular/forms';
import { AppFormat } from '../appFormat';

import Swal from 'sweetalert2/dist/sweetalert2.js';
import { IUsersystem } from '../interfaces/usersystem';
import { OperadorService } from '../services/operador.service';
import { SearchService } from '../services/search.service';
import { CustomerService } from '../services/customer.service';
import { ICustomer } from '../interfaces/customer';
import { IEvaluation } from '../interfaces/evaluation';
import { IOrder } from '../interfaces/order';
import { ExportExcelService } from '../services/export-excel.service';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss'],
  host: { 'class': 'wrapper-customers' }
})
export class CustomersComponent implements OnInit {

  public operador: IUsersystem

  public optionOpen: boolean = false
  public optionTimeout: any = null

  public num_todos: number = 0
  public num_detrator: number = 0
  public num_passivo: number = 0
  public num_promotor: number = 0
  public num_bloqueado: number = 0

  public loadingCustomer: boolean = false
  public loadingDetail: boolean = false
  public loadingTab: boolean = false
  public loadingDetailIntern: boolean = false

  public page: number = 1
  public pageEvaluation: number = 1
  public pageOrders: number = 1

  public openid: number = null

  public tab: string = 'todos'

  public open: boolean = false
  public openShopping: boolean = false
  public openEvaluation: boolean = false
  public showConfirmUnblocked: boolean = false
  public showConfirmDelete: boolean = false

  private query

  private queryEvaluation
  private queryOrders

  private endListEvaluation: boolean = false
  private endListOrders: boolean = false

  public buttonContactHidden: boolean = true

  public subscribeSearch: Subscription

  public search: string = ''
  private timeoutSearch = null

  public selector: string = '.wrapper-customers';

  public customers: ICustomer[]
  public customer: ICustomer

  public customerFrm: FormGroup

  public status: FormControl
  public isExportLoading: boolean = false
  public modalExportOpen: boolean = false

  constructor(private _searchService: SearchService,
    private _customerService: CustomerService,
    private _exportExcelService: ExportExcelService) {
    this.query = { page: this.page }

    //this.operador = this._operadorService.getOperador()

    this.subscribeSearch = this._searchService._searchCustomer.subscribe(res => {
      this.search = res
      if (this.timeoutSearch) clearTimeout(this.timeoutSearch)

      this.timeoutSearch = setTimeout(()=>{

        this.loadingTab = true

        this.num_todos = 0
        this.num_detrator = 0
        this.num_passivo = 0
        this.num_promotor = 0
        this.num_bloqueado = 0

        this.closeDetail()
        this.changeTab(this.tab)

      }, 300)
    })
  }

  ngOnInit(): void {
    this.customer = {
      idusuario: 0
    }

    this.createFormControls()
    this.createForm()

    this.loadingTab = false
    this.query['situacao'] = 'todos'
    this.find()
  }

  onExport() {

    this.isExportLoading = true
    setTimeout(()=>{
      this.modalExportOpen = true
    }, 100)

    //let idpedido_situacao = this.query['idpedido_situacao']
    //delete this.query['idpedido_situacao']

    let page = this.query['page']

    this.query['page'] = 'all'

    this._customerService.search(this.query).subscribe(data => {
      let customers = data.customers

      if (customers.length > 0) {

        let dataForExcel = [];

        customers.forEach((row: any) => {
          dataForExcel.push(Object.values(row))
        })

        let title = 'Clientes'

        let reportData = {
          title: title,
          data: dataForExcel,
          headers: Object.keys(customers[0])
        }

        this._exportExcelService.exportExcel(reportData)
      } else {
        Swal.fire("Ops!", "Não há nenhuma informação para ser exportada. Selecione outro filtro!", "error")
      }

      this.modalExportOpen = false
      setTimeout(() => {
        this.isExportLoading = false
      }, 300)

      this.query['page'] = page
      //this.query['idpedido_situacao'] = idpedido_situacao
    })
  }

  closeDetail() {
    this.open = false
    this.buttonContactHidden = true
  }

  toggleOptions(): void {
    this.optionOpen=!this.optionOpen

    this.clearOptions()
  }

  hideOptions(): void {
    if (this.optionOpen) {
      if (this.optionTimeout) clearTimeout(this.optionTimeout)

      this.optionTimeout = setTimeout(()=>{
        this.optionOpen = false
      }, 2000)
    }
  }

  clearOptions(): void {
    if (this.optionTimeout) clearTimeout(this.optionTimeout)
  }

  changeTab(tab): void {
    this.tab = tab
    this.page = 1

    this.loadingTab = false

    delete this.query['situation']
    delete this.query['disabled']

    /*
    public num_detrator: number = 0
    public num_passivo: number = 0
    public num_promotor: number = 0
    public num_bloqueado: number = 0
    */

    switch(tab)
    {
      case 'detrator':
        this.query['situation'] = 'detrator'
        break
      case 'passivo':
        this.query['situation'] = 'passivo'
        break
      case 'promotor':
        this.query['situation'] = 'promotor'
        break
      case 'bloqueado':
        this.query['disabled'] = 'S'
        break
    }

    this.find()
  }

  createFormControls() {
    this.status = new FormControl('')
  }

  createForm() {
    this.customerFrm = new FormGroup({
      status: this.status
    })
  }

  onScroll() {
    if (!this.loadingCustomer) {
      this.page = this.page + 1;
      this.find()
    }
  }

  find() {
    this.loadingCustomer = true

    this.query['page'] = this.page

    if (this.search != '') {
      this.query['search'] = this.search
    } else {
      if (this.query['search']) {
        delete this.query['search']
      }
    }

    //str: string, sort: string, direction: string, page: number

    this._customerService.search(this.query).subscribe(res => {
      this.customers = this.page > 1 ? this.customers.concat(res.customers) : res.customers

      if (res.num_todos) {
        this.num_todos = res.num_todos
        this.num_detrator = res.num_detrator
        this.num_passivo = res.num_passivo
        this.num_promotor = res.num_promotor
        this.num_bloqueado = res.num_bloqueado
      }

      this.loadingCustomer = false
      this.loadingTab = false
    })
  }

  openDetail(customer:ICustomer, i: number) {
    document.getElementById('detailCustomer').scrollTop = 0

    this.showConfirmUnblocked = false
    this.showConfirmDelete = false
    this.loadingDetail = true

    this.closeViewAllEvaluation()
    this.closeViewAllOrders()

    this._customerService.getCustomerID(customer.idusuario).subscribe(res => {
      if (res.success) {
        this.customer = res

        for(let i in this.customer.evaluation) {
          this.customer.evaluation[i]['data'] = AppFormat.getDateDescription(this.customer.evaluation[i].dt_cadastro);
        }
      }
      this.loadingDetail = false;
      setTimeout(()=>{
        this.isVisibleIntoView()
      },300)
    });

    this.open = true

    this.customer = customer

    this.openid = i
  }

  onScrollOrders() {
    if (!this.loadingDetailIntern && this.endListOrders == false) {
      this.pageOrders = this.pageOrders + 1;
      this.findOrders()
    }
  }

  onScrollEvaluation() {
    if (!this.loadingDetailIntern && this.endListEvaluation == false) {
      this.pageEvaluation = this.pageEvaluation + 1;
      this.findEvaluation()
    }
  }

  viewAllOrders() {
    this.optionOpen = false
    document.getElementById('detailCustomer').scrollTop = 0;
    this.openShopping = true

    if (!this.customer.orders) {
      this.customer.orders = []
      this.findOrders()
    }

  }

  findOrders() {
    this.queryOrders['page'] = this.pageOrders

    this.loadingDetailIntern = true;
    this._customerService.getCustomerOrderID(this.customer.idusuario, this.queryOrders).subscribe(res => {
      if (res['success']) {

        for(let i in res.orders) {
          if (res.orders[i].emfalta) {
            for(let j in res.orders[i].emfalta) {

              for(let h in res.orders[i].products) {

                if (res.orders[i].products[h].idproduto_geral == res.orders[i].emfalta[j].for_idproduto_geral) {
                  if(!res.orders[i].products[h].emfalta) res.orders[i].products[h].emfalta = []
                  res.orders[i].products[h].emfalta.push(res.orders[i].emfalta[j])
                }

              }
            }
          }
        }

        this.customer.orders = this.customer.orders.concat(res.orders)
        if (res.orders.length == 0) {
          this.endListOrders = true
        }
      }
      this.loadingDetailIntern = false;
    });
  }

  viewAllProducts(o: IOrder) {
    if (!o.open) {
      o.open = true;
    } else {
      o.open = false
    }
  }

  closeViewAllOrders() {
    this.openShopping = false
    this.endListOrders = false
    this.pageOrders = 1
    this.queryOrders = {
      page: 1
    }
  }

  viewAllEvaluation() {
    this.optionOpen = false
    document.getElementById('detailCustomer').scrollTop = 0;
    this.openEvaluation = true

    if (!this.customer.evaluations) {
      this.customer.evaluations = []
      this.findEvaluation()
    }

  }

  findEvaluation() {
    this.queryEvaluation['page'] = this.pageEvaluation

    this.loadingDetailIntern = true;
    this._customerService.getCustomerEvaluationID(this.customer.idusuario, this.queryEvaluation).subscribe(res => {
      if (res['success']) {
        for(let i in res.evaluation) {
          res.evaluation[i]['data'] = AppFormat.getDateDescription(res.evaluation[i].dt_cadastro);

          if (res.evaluation[i].order && res.evaluation[i].order.emfalta) {
            for(let j in res.evaluation[i].order.emfalta) {

              for(let h in res.evaluation[i].order.products) {

                if (res.evaluation[i].order.products[h].idproduto_geral == res.evaluation[i].order.emfalta[j].for_idproduto_geral) {
                  if(!res.evaluation[i].order.products[h].emfalta) res.evaluation[i].order.products[h].emfalta = []
                  res.evaluation[i].order.products[h].emfalta.push(res.evaluation[i].order.emfalta[j])
                }

              }
            }
          }
        }

        this.customer.evaluations = this.customer.evaluations.concat(res.evaluation)

        if (res.evaluation.length == 0) {
          this.endListEvaluation = true
        }


      }
      this.loadingDetailIntern = false;
    });
  }

  openDetailEvaluation(e:IEvaluation) {
    if (!e.open) {
      e.open = true;
    } else {
      e.open = false
    }
  }

  closeViewAllEvaluation() {
    this.openEvaluation = false
    this.endListEvaluation = false
    this.pageEvaluation = 1
    this.queryEvaluation = {
      page: 1
    }
  }

  onSubmit() {
    if (this.customerFrm.valid) {
    }
    return false
  }

  cleanPhone(n) {
    if (n && n != '') {
      return n.replace(/\D/g, '');
    } else {
      return ''
    }
  }

  onScrolldetailCustomer(ev): void {
    this.isVisibleIntoView()
  }

  isVisibleIntoView() : void {
    this.buttonContactHidden = this.isScrolledIntoView(document.getElementById('footerContact'))
  }

  isScrolledIntoView(el) : boolean {
    var rect = el.getBoundingClientRect();
    var elemTop = rect.top;

    var isVisible = (elemTop >= 0) && (elemTop <= window.innerHeight);
    return isVisible;
  }

  goToContact() : void {
    document.getElementById('footerContact').scrollIntoView({behavior: "smooth"})
  }

  getClassCustomerNPS(nps) {
    let classname = 'p'
    if (nps < -9) {
      classname += '-'

      nps *= -1
    }

    if (nps == 100) {
      classname += '100'
    } else if (nps >= 90) {
      classname += '90'
    } else if (nps >= 80) {
      classname += '80'
    } else if (nps >= 70) {
      classname += '70'
    } else if (nps >= 60) {
      classname += '60'
    } else if (nps >= 50) {
      classname += '50'
    } else if (nps >= 40) {
      classname += '40'
    } else if (nps >= 30) {
      classname += '30'
    } else if (nps >= 20) {
      classname += '20'
    } else if (nps >= 10) {
      classname += '10'
    } else {
      classname += '0'
    }

    return classname
  }

  blockCustomer() {
    Swal.fire({
      title: 'Você deseja bloquear o cliente?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!'
    }).then((result) => {
      if (result.value) {
        this.loadingDetail = true

        this._customerService.blockCustomerID(this.customer.idusuario).subscribe(res => {
          if (res['success']) {
            this.customer.status = 'I'

            this.customer.blocked_by = res['blocked_by']
            this.customer.blocked_date = res['blocked_date']

            this.num_bloqueado = this.num_bloqueado + 1
          }

          this.loadingDetail = false
        })

      }
    })
  }

  unblockCustomer() {
    Swal.fire({
      title: 'Você deseja desbloquear o cliente?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!'
    }).then((result) => {
      if (result.value) {
        this.loadingDetail = true

        this._customerService.unblockCustomerID(this.customer.idusuario).subscribe(res => {
          if (res['success']) {
            this.customer.status = 'A'

            this.num_bloqueado = this.num_bloqueado - 1

            this.showConfirmUnblocked = true
            setTimeout(()=>{
              this.showConfirmUnblocked = false
            }, 1500)
          }

          this.loadingDetail = false
        })

      }
    })
  }

  deleteCustomer() {
    Swal.fire({
      title: 'Você deseja excluir o cliente?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!'
    }).then((result) => {
      if (result.value) {
        this.loadingDetail = true

        this._customerService.deleteCustomerID(this.customer.idusuario).subscribe(res => {
          if (res['success']) {
            this.customer.status = 'D'

            this.find()

            this.showConfirmDelete = true
            setTimeout(()=>{
              this.closeDetail()
            }, 1500)
          }

          this.loadingDetail = false
        })

      }
    })
  }

}
